import { useEffect, useState } from "react";
import Navbar from "../layouts/nav";
import Footer from "../layouts/footer";

export default function Gallery(){

    function doNothing(e){
        e.preventDefault();
        return;
    }

    useEffect(() => {
		// List of JS files to reload
		const jsFiles = [
		//   'assets/js/scrolltoTop.js',
		  'assets/js/custom.js',
		];
	
		// Create script elements for each JS file
		jsFiles.forEach((filePath) => {
		  const script = document.createElement('script');
		  script.src = filePath;
		  script.async = true;
		  document.body.appendChild(script);
		});
	
		// Clean up the script elements when the component unmounts
		return () => {
		  jsFiles.forEach((filePath) => {
			const script = document.querySelector(`[src="${filePath}"]`);
			if (script) {
			  document.body.removeChild(script);
			}
		  });
		};
	  }, []);

    return(
        <>
    <Navbar active={'dropdown'} style={'#1A374D'}/>
    
	<div className="untree_co-section" style={{paddingBottom: 0}}>
		<div className="container">
			<div className="row mb-5 justify-content-center">
				<div className="col-lg-6 text-center">
					<h2 className="section-title text-center" style={{marginTop: '5.5rem', fontSize: '4rem'}}>Gallery</h2>
                    <p style={{fontWeight: 'bold'}}>Welcome to the Animal Encyclopedia Gallery!</p><p>

Step into a captivating visual journey through the breathtaking diversity of the animal kingdom. In this curated gallery, you'll discover an array of fascinating creatures, each uniquely adapted to its environment and boasting incredible traits.</p>
                </div>
            </div>
        </div>
    </div>
    <div className="gallery_wrapper">
        <div className="gallery_gallery" onClick = {doNothing}>
            <div className="gallery_gallery__item gallery_gallery__item--1">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1564349683136-77e08dba1ef7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Eating Panda</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--2">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/reserve/wrev1ljvQ6KlfyljCQG0_lion.jpg?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Roaring Lion</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--3">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1521651201144-634f700b36ef?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Elephants in a field</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--4">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1484406566174-9da000fda645?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Buck in the wild</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--5">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1500479694472-551d1fb6258d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>A little fox</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--6">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1460999158988-6f0380f81f4d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Group of horses</span>
                    </div>
                </a>
            </div>
        </div>

        <div className="gallery_gallery"  onClick = {doNothing}>
            <div className="gallery_gallery__item gallery_gallery__item--1">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1559736139-6531cc82432e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Wolf</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--2">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1515513284006-9a59075694b7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Gorilla</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--3">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1456926631375-92c8ce872def?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGFuaW1hbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Cheetah</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--4">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1574068468668-a05a11f871da?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8YW5pbWFsc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Blue Bird</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--5">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1474511320723-9a56873867b5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGFuaW1hbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Fox</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--6">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1437622368342-7a3d73a34c8f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGFuaW1hbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Turtle</span>
                    </div>
                </a>
            </div>
        </div>

        <div className="gallery_gallery"  onClick = {doNothing}>
            <div className="gallery_gallery__item gallery_gallery__item--1">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1504006833117-8886a355efbf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGFuaW1hbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Squirrel</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--2">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1444464666168-49d633b86797?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGFuaW1hbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Kingfisher</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--3">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1493916665398-143bdeabe500?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fGFuaW1hbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Dog</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--4">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://plus.unsplash.com/premium_photo-1666361680434-551a4f0bbe9a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fGFuaW1hbHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Goat</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--5">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1557050543-4d5f4e07ef46?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YW5pbWFscyUyMGluJTIwdGhlJTIwd2lsZHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Elephant</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--6">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1531943865082-287018833410?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8YW5pbWFscyUyMGluJTIwdGhlJTIwd2lsZHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Baby Squirrel</span>
                    </div>
                </a>
            </div>
        </div>

        <div className="gallery_gallery"  onClick = {doNothing}>
            <div className="gallery_gallery__item gallery_gallery__item--1">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1534966037352-ba3ca007a1fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8YmFieSUyMHBlbmd1aW58ZW58MHwwfDB8fHww&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Baby Penguin</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--2">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1515253845645-6692c3cded82?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHwwfDB8fHww&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Reindeer</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--3">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1617780491381-6baf955d723f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHwwfDB8fHww&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Blue bird</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--4">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1598431362284-d0dc9129010b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHwwfDB8fHww&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Spider</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--5">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1610944301914-fe136192aeb8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHwwfDB8fHww&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Duck</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--6">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1483470873734-93599652a354?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjJ8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHwwfDB8fHww&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Lioness</span>
                    </div>
                </a>
            </div>
        </div>

        <div className="gallery_gallery" onClick = {doNothing}>
            <div className="gallery_gallery__item gallery_gallery__item--1">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1595527225657-8f0d294d02ce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjN8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHwwfDB8fHww&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Owl</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--2">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1628006020983-5f032bedb369?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Z29sZCUyMGZpc2h8ZW58MHwwfDB8fHww&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Gold Fish</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--3">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1503066211613-c17ebc9daef0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjF8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHwwfDB8fHww&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>White Tiger</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--4">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1557008075-7f2c5efa4cfd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YW5pbWFscyUyMGluJTIwdGhlJTIwd2lsZHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Red Fox</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--5">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1470093851219-69951fcbb533?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8d2hpdGUlMjBmb3h8ZW58MHwwfDB8fHww&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Snow Fox</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--6">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1508710599415-734cc9b287fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjF8fHdoaXRlJTIwZm94fGVufDB8MHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>White Cat</span>
                    </div>
                </a>
            </div>
        </div>

        <div className="gallery_gallery"  onClick = {doNothing}>
            <div className="gallery_gallery__item gallery_gallery__item--1">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1515606805638-2f1ea2dce9e1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTd8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Eagle</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--2">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1581450266720-7fef5aa20d1d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTh8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Giraffe</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--3">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1430514731097-e2d6deb9ebd6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NjN8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Elephant</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--4">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1621873237752-62a3bfac2806?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDZ8fGFuaW1hbHMlMjBpbiUyMHRoZSUyMHdpbGR8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Yak</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--5">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1630771077377-674b39a13f58?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzR8fGZpc2hlc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Nemo</span>
                    </div>
                </a>
            </div>
            <div className="gallery_gallery__item gallery_gallery__item--6">
                <a href="#" className="gallery_gallery__link">
                    <img src="https://images.unsplash.com/photo-1549608276-5786777e6587?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8YmlyZHN8ZW58MHwwfDB8fHww&auto=format&fit=crop&w=500&q=80" className="gallery_gallery__image" />
                    <div className="gallery_gallery__overlay">
                        <span>Macaw</span>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <Footer/>
        </>
    );
}